import AccountsList from './AccountsList';

export default function ReceivablesList() {
    return <AccountsList kind="receivable" />;
}
